module.exports = __webpack_public_path__ + "img/emision2.d3df018a.png";